function transHeader() {
    const transHeader = document.querySelector('.bz_header_main.trans_header');
    if (!transHeader) return;

    const secheader = document.querySelector('.header_wrap');
    const scrollThreshold = 200;
    secheader.classList.add('header_scroll_up');

    function updateTransClass() {
        const firstLayerOpen = document.querySelector('.first_layer[open]');
        const sidebarOpen = document.querySelector('.sidebar_menu.open');

        if (firstLayerOpen || sidebarOpen) {
            transHeader.classList.remove('bz_trans');
        } else {
            transHeader.classList.add('bz_trans');
        }
    }

    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > scrollThreshold) {
            setTimeout(() => {
                secheader.classList.add('bz_past_scroll');
            }, 300);
        } else {
            setTimeout(() => {
                secheader.classList.remove('bz_past_scroll');
            }, 300);
        }
    });
    transHeader.addEventListener('mouseenter', () => {
       transHeader.classList.remove('bz_trans');
    });

    transHeader.addEventListener('mouseleave', () => {
        updateTransClass();
    });

    const firstLayer = document.querySelectorAll('.first_layer');
    if (firstLayer) {
        firstLayer.forEach(layer => {
            new MutationObserver(updateTransClass).observe(layer, {
                attributes: true,
                attributeFilter: ['open']
            });
        });
    }
    const sidebarMenu = document.querySelector('.sidebar_menu');
    if (sidebarMenu) {
        new MutationObserver(updateTransClass).observe(sidebarMenu, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
    updateTransClass();
}

[
 'DOMContentLoaded',
 'shopify:section:load',
 'shopify:section:unload',
 'shopify:section:select',
 'shopify:section:deselect',
 'shopify:section:reorder'
].forEach(e => addEventListener(e, transHeader));




// function transHeader() {
//     const transHeader = document.querySelector('.bz_header_main.trans_header');
//     if(transHeader){
//         const secheader = document.querySelector('.header_wrap');
//         const scrollThreshold = 200;
//         // function checkMenuState() {
//         //     const firstLayerOpen = document.querySelector('.first_layer[open]');
//         //     const sidebarOpen = document.querySelector('.sidebar_menu.open');

//         //     if (firstLayerOpen || sidebarOpen) {
//         //         transHeader.classList.remove('bz_trans');
//         //     } else {
//         //         transHeader.classList.add('bz_trans');
//         //     }
//         // }

//         function checkMenuState() {
//             const firstLayerOpen = document.querySelector('.first_layer[open]');
//             const sidebarOpen = document.querySelector('.sidebar_menu.open');

//             if (firstLayerOpen || sidebarOpen) {
//                 transHeader.classList.remove('bz_trans');
//                 return true;
//             }
//             return false;
//         }

//         window.addEventListener('scroll', () => {
//             const currentScroll = window.pageYOffset;
//             if (currentScroll > scrollThreshold) {
//                 setTimeout(() => {
//                     secheader.classList.add('bz_past_scroll');
//                 }, 300);
//             } else {
//                 setTimeout(() => {
//                     secheader.classList.remove('bz_past_scroll');
//                 }, 300);
//             }
//             checkMenuState();
//         });
//         transHeader.addEventListener('mouseenter', () => {
//             if (!checkMenuState()) {
//                 transHeader.classList.remove('bz_trans');
//             }
//         });

//         transHeader.addEventListener('mouseleave', () => {
//             if (!checkMenuState()) {
//                 transHeader.classList.add('bz_trans');
//             }
//         });
//         checkMenuState();
//     }
// }
// ['DOMContentLoaded', 'shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder']
// .forEach(e => addEventListener(e, transHeader));



// On scroll up js 
function scrollUpheader() {
    const header = document.querySelector('[data-header-action="on_scroll_up"]');
    if(header){
        const secheader = document.querySelector('.header_wrap');
        let lastScroll = 0;
        const scrollThreshold = 200;
        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset;
            // Sidebar / mega drawer open: keep the header (and its drawer) in place
            if (document.body.classList.contains('sidebar_open')) {
                lastScroll = currentScroll;
                return;
            }
            if (currentScroll > scrollThreshold) {
                if (currentScroll < lastScroll) {
                    secheader.classList.remove('scroll_up');
                } else {
                    secheader.classList.add('scroll_up');
                }
            } else {
                secheader.classList.remove('scroll_up');
            }
            lastScroll = currentScroll;
        });
    }
}
['DOMContentLoaded', 'shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder']
.forEach(e => addEventListener(e, scrollUpheader));

// header height count
function updateHeaderHeightVariable() {
    const sectionHeader = document.querySelector('.header_wrap');
    const sectionHeaderDiv = document.querySelector('header.bz_header_main');
    const body = document.querySelector('body');

    if (sectionHeader && sectionHeaderDiv) {
        const headerHeight = sectionHeaderDiv.offsetHeight;
        const headerHeightValue = `${headerHeight}px`;
        document.documentElement.style.setProperty('--header-height', headerHeightValue);
        if (body) {
            body.style.setProperty('--header-height', headerHeightValue);
        }
    }
}
window.addEventListener('load', updateHeaderHeightVariable);
window.addEventListener('resize', updateHeaderHeightVariable);
window.addEventListener('scroll', updateHeaderHeightVariable);

// Same menu title: only the scrolling bar lowest in the header block list stays visible
function bzLastScrollBar() {
  document.querySelectorAll('header.bz_header_main').forEach((header) => {
    const groups = {};
    header.querySelectorAll('.bz_mega_item--hsb').forEach((el) => {
      const key = el.getAttribute('data-mega-title') || '';
      (groups[key] ||= []).push(el);
    });
    Object.keys(groups).forEach((key) => {
      const list = groups[key];
      list.forEach((el, i) => el.classList.toggle('bz_hsb--skip', i !== list.length - 1));
    });
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach((e) => addEventListener(e, bzLastScrollBar));


// Menu badges: each "Menu badge" block prints a hidden marker; put its badge next to every
// menu label with the same title (main label, child, grandchild and mega menu columns)
function bzHandle(text) {
  return (text || '').toLowerCase().trim().replace(/['’"]/g, '').replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');
}
function bzMenuBadges() {
  document.querySelectorAll('header.bz_header_main').forEach((header) => {
    const badges = {};
    header.querySelectorAll('[data-menu-badge]').forEach((marker) => {
      const key = bzHandle(marker.dataset.title);
      if (key && marker.dataset.text && !badges[key]) badges[key] = marker.dataset;
    });

    header.querySelectorAll('.menu_wrap a, .menu_wrap .bz_mega_trigger, .bz_mwb_heading, .bz_mwb_link').forEach((el) => {
      if (el.closest('[data-mega-title]') && !el.matches('.bz_mwb_heading, .bz_mwb_link')) return;
      // The label text is its own link inside the row. The row already carries the badge.
      if (el.matches('a.bz_mlabel')) return;
      el.querySelectorAll(':scope > .bz_menu_badge, a.bz_mlabel > .bz_menu_badge').forEach((extra) => {
        if (!extra.parentElement.classList.contains('bz_mlabel_wrap')) extra.remove();
      });
      const label = el.querySelector('.bz_mlabel') || el.querySelector(':scope > span.break') || el;
      const text = [...label.childNodes]
        .filter((n) => !(n.nodeType === 1 && n.classList.contains('bz_menu_badge')))
        .map((n) => n.textContent)
        .join('');
      const want = badges[bzHandle(text)];
      const holder = label === el ? el : label.parentElement;
      const current = holder.querySelector(':scope > .bz_menu_badge');
      const style = want ? `--badge-bg: ${want.bg}; --badge-color: ${want.color};` : '';
      if (current && want && current.textContent === want.text && current.getAttribute('style') === style) return;
      current?.remove();
      if (!want) return;

      const badge = document.createElement('span');
      badge.className = 'bz_menu_badge flex_shrink f_b_14';
      badge.setAttribute('style', style);
      badge.textContent = want.text;
      if (label === el) el.appendChild(badge);
      else label.after(badge);
    });
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach((e) => addEventListener(e, bzMenuBadges));

// Theme editor: badge / menu blocks re-render on their own, so re-apply badges after DOM changes
if (window.Shopify && Shopify.designMode) {
  let bzBadgeTimer;
  new MutationObserver((records) => {
    const onlyBadges = records.every((r) =>
      [...r.addedNodes, ...r.removedNodes].every((n) => n.nodeType !== 1 || n.classList.contains('bz_menu_badge'))
    );
    if (onlyBadges) return;
    clearTimeout(bzBadgeTimer);
    bzBadgeTimer = setTimeout(() => {
      bzLastScrollBar();
      bzMenuBadges();
    }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
}